var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"welcome-layout",style:({
    background: `url(${
      _vm.theme.backgroundUrl || require('@/assets/images/welcome-background.svg')
    })`,
  })},[_c('img',{staticClass:"logo",attrs:{"src":_vm.theme.logo.external || require('@/assets/images/logo-hotel.svg'),"alt":"Logo Hotel"}}),(_vm.$vuetify.breakpoint.mdAndUp)?_c('div',{staticClass:"language-select-desktop"},[_c('language-select')],1):_vm._e(),_c('z-page-transition',{attrs:{"type":"fade"}},[_c('router-view')],1),_c('img',{staticClass:"powered-by",attrs:{"src":require("@/assets/images/poweredby.svg"),"alt":"Powered by Zoox"}}),_c('notification')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }